import {
	createRouter,
	createWebHistory
} from "vue-router"
import Layout from '@/layout'
import useUserStore from '@/store/modules/user'
import {
	goLogin
} from '@/utils/common.js'
import {
	ElMessage
} from 'element-plus'

const constantRoutes = [{
	path: '/',
	redirect: '/dashboard',
	meta: {
		title: '工作台',
		// icon: 'icon_gzt',
	},
	component: Layout,
	children: [{
		path: '/dashboard',
		name: 'Dashboard',
		component: () => import('@/views/dashboard/index.vue'),
	}, {
		path: '/accountMessPage',
		name: 'AccountMessPage',
		component: () => import('@/views/myMessPage/accountMessPage.vue'),
	}, {
		path: '/realNameAuthentication',
		name: 'RealNameAuthentication',
		component: () => import('@/views/myMessPage/realNameAuthentication.vue'),
	}, {
		path: '/incomeAndExpenditureDetails',
		name: 'IncomeAndExpenditureDetails',
		component: () => import('@/views/myMessPage/incomeAndExpenditureDetails.vue'),
	}, {
		path: '/incomeAndExpenditureDetailsToDetails',
		name: 'IncomeAndExpenditureDetailsToDetails',
		component: () => import('@/views/myMessPage/incomeAndExpenditureDetailsToDetails.vue'),
	}, {
		path: '/myFeedback',
		name: 'MyFeedback',
		component: () => import('@/views/myMessPage/myFeedback.vue'),
	}, {
		path: '/feedbackDetails',
		name: 'FeedbackDetails',
		component: () => import('@/views/myMessPage/feedbackDetails.vue'),
	}, {
		path: '/exportQueuePage',
		name: 'ExportQueuePage',
		component: () => import('@/views/myMessPage/exportQueuePage.vue'),
	}, {
		path: '/uploadQueuePage',
		name: 'UploadQueuePage',
		component: () => import('@/views/myMessPage/uploadQueuePage.vue'),
	}, {
		path: '/securitySettingPage',
		name: 'SecuritySettingPage',
		component: () => import('@/views/myMessPage/securitySettingPage.vue'),
	}, {
		path: '/memberAccount',
		name: 'MemberAccount',
		component: () => import('@/views/groupAccount/memberAccount.vue'),
	}, {
		path: '/memberAccountAdd',
		name: 'MemberAccountAdd',
		component: () => import('@/views/groupAccount/memberAccountAdd.vue'),
	}, {
		path: '/memberAccountEdit',
		name: 'MemberAccountEdit',
		component: () => import('@/views/groupAccount/memberAccountEdit.vue'),
	}, {
		path: '/departmentManagement',
		name: 'DepartmentManagement',
		component: () => import('@/views/groupAccount/departmentManagement.vue'),
	}, {
		path: '/companyInformation',
		name: 'CompanyInformation',
		component: () => import('@/views/groupAccount/companyInformation.vue'),
	}, {
		path: '/corporateCultureWall',
		name: 'CorporateCultureWall',
		component: () => import('@/views/groupAccount/corporateCultureWall.vue'),
	}, {
		path: '/changeLogs',
		name: 'ChangeLogs',
		component: () => import('@/views/groupAccount/changeLogs.vue'),
	}, {
		path: '/changeLogsDetails',
		name: 'ChangeLogsDetails',
		component: () => import('@/views/groupAccount/changeLogsDetails.vue'),
	}, {
		path: '/groupConfiguration',
		name: 'GroupConfiguration',
		component: () => import('@/views/groupAccount/groupConfiguration.vue'),
	}, {
		path: '/memberArchive',
		name: 'MemberArchive',
		type: 'archive_member_type',
		component: () => import('@/views/archivePage/memberArchive.vue'),
	}, {
		path: '/memberArchiveNewMaterials',
		name: 'MemberArchiveNewMaterials',
		component: () => import('@/views/archivePage/memberArchiveNewMaterials.vue'),
	}, {
		path: '/materialsDetails',
		name: 'MaterialsDetails',
		component: () => import('@/views/archivePage/materialsDetails.vue'),
	}, {
		path: '/materialsEdit',
		name: 'MaterialsEdit',
		component: () => import('@/views/archivePage/materialsEdit.vue'),
	}, {
		path: '/generalArchive',
		name: 'GeneralArchive',
		type: 'archive_overall_type',
		component: () => import('@/views/archivePage/generalArchive.vue'),
	}, {
		path: '/generalArchiveCreateFile',
		name: 'GeneralArchiveCreateFile',
		component: () => import('@/views/archivePage/generalArchiveCreateFile.vue'),
	}, {
		path: '/expirationWarning',
		name: 'ExpirationWarning',
		type: 'archive_warning_type',
		component: () => import('@/views/archivePage/expirationWarning.vue'),
	}, {
		path: '/equipmentRegistration',
		name: 'EquipmentRegistration',
		type: 'archive_device_register_type',
		component: () => import('@/views/archivePage/equipmentRegistration.vue'),
	}, {
		path: '/equipmentRegistrationDetails',
		name: 'EquipmentRegistrationDetails',
		component: () => import('@/views/archivePage/equipmentRegistrationDetails.vue'),
	}, {
		path: '/addEquipmentPage',
		name: 'AddEquipmentPage',
		component: () => import('@/views/archivePage/addEquipmentPage.vue'),
	}, {
		path: '/equipmentApproval',
		name: 'EquipmentApproval',
		type: 'archive_device_approve_type',
		component: () => import('@/views/archivePage/equipmentApproval.vue'),
	}, {
		path: '/equipmentApprovalDetails',
		name: 'EquipmentApprovalDetails',
		component: () => import('@/views/archivePage/equipmentApprovalDetails.vue'),
	}, {
		path: '/archiveSetting',
		name: 'ArchiveSetting',
		component: () => import('@/views/archivePage/archiveSetting.vue'),
	}, {
		path: '/warningContent',
		name: 'WarningContent',
		component: () => import('@/views/archivePage/warningContent.vue'),
	}, {
		path: '/mailPage',
		name: 'MailPage',
		component: () => import('@/views/systemNotification/mailPage.vue'),
	}, {
		path: '/mailDetailsPage',
		name: 'MailDetailsPage',
		component: () => import('@/views/systemNotification/mailDetailsPage.vue'),
	}, {
		path: '/pushMailPage',
		name: 'PushMailPage',
		component: () => import('@/views/systemNotification/pushMailPage.vue'),
	}, {
		path: '/bulletinPage',
		name: 'BulletinPage',
		component: () => import('@/views/systemNotification/bulletinPage.vue'),
	}, {
		path: '/bulletinDetailsPage',
		name: 'BulletinDetailsPage',
		component: () => import('@/views/systemNotification/bulletinDetailsPage.vue'),
	}, {
		path: '/pushBulletinPage',
		name: 'PushBulletinPage',
		component: () => import('@/views/systemNotification/pushBulletinPage.vue'),
	}, {
		path: '/trendsPage',
		name: 'TrendsPage',
		component: () => import('@/views/systemNotification/trendsPage.vue'),
	}, {
		path: '/noticePage',
		name: 'NoticePage',
		component: () => import('@/views/systemNotification/noticePage.vue'),
	}, {
		path: '/noticeDetailsPage',
		name: 'NoticeDetailsPage',
		component: () => import('@/views/systemNotification/noticeDetailsPage.vue'),
	}, {
		path: '/pushNoticePage',
		name: 'PushNoticePage',
		component: () => import('@/views/systemNotification/pushNoticePage.vue'),
	}, {
		path: '/collectFeedbackPage',
		name: 'CollectFeedbackPage',
		component: () => import('@/views/systemNotification/collectFeedbackPage.vue'),
	}, {
		path: '/serviceStation',
		name: 'ServiceStation',
		component: () => import('@/views/systemNotification/serviceStation.vue'),
	}, {
		path: '/serviceStationDetails',
		name: 'ServiceStationDetails',
		component: () => import('@/views/systemNotification/serviceStationDetails.vue'),
	}, {
		path: '/noticeSetting',
		name: 'NoticeSetting',
		component: () => import('@/views/systemNotification/noticeSetting.vue'),
	}, {
		path: '/terminalPage',
		name: 'TerminalPage',
		component: () => import('@/views/toolbox/terminalPage.vue'),
	}, {
		path: '/operationLog',
		name: 'OperationLog',
		component: () => import('@/views/toolbox/operationLog.vue'),
	}, {
		path: '/instructionManual',
		name: 'InstructionManual',
		component: () => import('@/views/toolbox/instructionManual.vue'),
	}, {
		path: '/productDescriptionGenerator',
		name: 'ProductDescriptionGenerator',
		component: () => import('@/views/toolbox/productDescriptionGenerator.vue'),
	}, {
		path: '/productDescriptionGeneratorAddAndEdit',
		name: 'ProductDescriptionGeneratorAddAndEdit',
		component: () => import('@/views/toolbox/productDescriptionGeneratorAddAndEdit.vue'),
	}, {
		path: '/updateNotesGenerator',
		name: 'UpdateNotesGenerator',
		component: () => import('@/views/toolbox/updateNotesGenerator.vue'),
	}, {
		path: '/updateNotesGeneratorAddAndEditDocument',
		name: 'UpdateNotesGeneratorAddAndEditDocument',
		component: () => import('@/views/toolbox/updateNotesGeneratorAddAndEditDocument.vue'),
	}, {
		path: '/updateNotesGeneratorAddAndEditLogs',
		name: 'UpdateNotesGeneratorAddAndEditLogs',
		component: () => import('@/views/toolbox/updateNotesGeneratorAddAndEditLogs.vue'),
	}, {
		path: '/toolConfiguration',
		name: 'ToolConfiguration',
		component: () => import('@/views/toolbox/toolConfiguration.vue'),
	}, {
		path: '/taskCenter',
		name: 'TaskCenter',
		component: () => import('@/views/taskmasterPage/taskCenter.vue'),
	}, {
		path: '/taskCenterShowAll',
		name: 'TaskCenterShowAll',
		component: () => import('@/views/taskmasterPage/taskCenterShowAll.vue'),
	}, {
		path: '/taskCenterIntroduce',
		name: 'TaskCenterIntroduce',
		component: () => import('@/views/taskmasterPage/taskCenterIntroduce.vue'),
	}, {
		path: '/taskQueue',
		name: 'TaskQueue',
		component: () => import('@/views/taskmasterPage/taskQueue.vue'),
	}, {
		path: '/executionRecord',
		name: 'ExecutionRecord',
		component: () => import('@/views/taskmasterPage/executionRecord.vue'),
	}, {
		path: '/taskConfiguration',
		name: 'TaskConfiguration',
		component: () => import('@/views/taskmasterPage/taskConfiguration.vue'),
	}, {
		path: '/taskConfigurationAddAndEditTemplate',
		name: 'TaskConfigurationAddAndEditTemplate',
		component: () => import('@/views/taskmasterPage/taskConfigurationAddAndEditTemplate.vue'),
	}, {
		path: '/taskAddAndEdit',
		name: 'TaskAddAndEdit',
		component: () => import('@/views/taskmasterPage/taskAddAndEdit.vue'),
	}, {
		path: '/projectCenter',
		name: 'ProjectCenter',
		type: 'track_centre',
		component: () => import('@/views/projectTracking/projectCenter.vue'),
	}, {
		path: '/projectCreateAndIntroduceAndEdit',
		name: 'ProjectCreateAndIntroduceAndEdit',
		component: () => import('@/views/projectTracking/projectCreateAndIntroduceAndEdit.vue'),
	}, {
		path: '/myToDo',
		name: 'MyToDo',
		type: 'track_todo',
		component: () => import('@/views/projectTracking/myToDo.vue'),
	}, {
		path: '/myCreate',
		name: 'MyCreate',
		type: 'track_create',
		component: () => import('@/views/projectTracking/myCreate.vue'),
	}, {
		path: '/itemsRequiringAssistance',
		name: 'ItemsRequiringAssistance',
		type: 'track_create',
		component: () => import('@/views/projectTracking/itemsRequiringAssistance.vue'),
	}, {
		path: '/moduleAndRequirementCreateAndEditAndDetails',
		name: 'ModuleAndRequirementCreateAndEditAndDetails',
		component: () => import('@/views/projectTracking/moduleAndRequirementCreateAndEditAndDetails.vue'),
	}, {
		path: '/projectDashboard',
		name: 'ProjectDashboard',
		component: () => import('@/views/projectTracking/projectDashboard.vue'),
	}, {
		path: '/yearOnYearComparison',
		name: 'YearOnYearComparison',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/yearOnYearComparison.vue'),
	}, {
		path: '/moduleChargeDetails',
		name: 'ModuleChargeDetails',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/moduleChargeDetails.vue'),
	}, {
		path: '/moduleFinishDetails',
		name: 'ModuleFinishDetails',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/moduleFinishDetails.vue'),
	}, {
		path: '/moduleCreateDetails',
		name: 'ModuleCreateDetails',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/moduleCreateDetails.vue'),
	}, {
		path: '/moduleInspectionDetails',
		name: 'ModuleInspectionDetails',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/moduleInspectionDetails.vue'),
	}, {
		path: '/requirementHandleAssistDetails',
		name: 'RequirementHandleAssistDetails',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/requirementHandleAssistDetails.vue'),
	}, {
		path: '/requirementHandleDetails',
		name: 'RequirementHandleDetails',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/requirementHandleDetails.vue'),
	}, {
		path: '/requirementInspectionDetails',
		name: 'RequirementInspectionDetails',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/requirementInspectionDetails.vue'),
	}, {
		path: '/requirementFinishDetails',
		name: 'RequirementFinishDetails',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/requirementFinishDetails.vue'),
	}, {
		path: '/requirementFinishAssistDetails',
		name: 'RequirementFinishAssistDetails',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/requirementFinishAssistDetails.vue'),
	}, {
		path: '/requirementCreateDetails',
		name: 'RequirementCreateDetails',
		component: () => import('@/views/projectTracking/projectDashboardMemberDetails/requirementCreateDetails.vue'),
	}, {
		path: '/projectLeaderRankingList',
		name: 'ProjectLeaderRankingList',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/projectLeaderRankingList.vue'),
	}, {
		path: '/projectLeaderRankingDetails',
		name: 'ProjectLeaderRankingDetails',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/projectLeaderRankingDetails.vue'),
	}, {
		path: '/moduleCreateRankingList',
		name: 'ModuleCreateRankingList',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/moduleCreateRankingList.vue'),
	}, {
		path: '/moduleCreateRankingDetails',
		name: 'ModuleCreateRankingDetails',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/moduleCreateRankingDetails.vue'),
	}, {
		path: '/moduleChargeRankingList',
		name: 'ModuleChargeRankingList',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/moduleChargeRankingList.vue'),
	}, {
		path: '/moduleChargeRankingDetails',
		name: 'ModuleChargeRankingDetails',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/moduleChargeRankingDetails.vue'),
	}, {
		path: '/moduleFinishRankingList',
		name: 'ModuleFinishRankingList',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/moduleFinishRankingList.vue'),
	}, {
		path: '/moduleFinishRankingDetails',
		name: 'ModuleFinishRankingDetails',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/moduleFinishRankingDetails.vue'),
	}, {
		path: '/requirementCreateRankingList',
		name: 'RequirementCreateRankingList',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/requirementCreateRankingList.vue'),
	}, {
		path: '/requirementCreateRankingDetails',
		name: 'RequirementCreateRankingDetails',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/requirementCreateRankingDetails.vue'),
	}, {
		path: '/requirementHandlerRankingList',
		name: 'RequirementHandlerRankingList',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/requirementHandlerRankingList.vue'),
	}, {
		path: '/requirementHandlerRankingDetails',
		name: 'RequirementHandlerRankingDetails',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/requirementHandlerRankingDetails.vue'),
	}, {
		path: '/requirementFinishRankingList',
		name: 'RequirementFinishRankingList',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/requirementFinishRankingList.vue'),
	}, {
		path: '/requirementFinishRankingDetails',
		name: 'RequirementFinishRankingDetails',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/requirementFinishRankingDetails.vue'),
	}, {
		path: '/requirementAssistantRankingList',
		name: 'RequirementAssistantRankingList',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/requirementAssistantRankingList.vue'),
	}, {
		path: '/requirementAssistantRankingDetails',
		name: 'RequirementAssistantRankingDetails',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/requirementAssistantRankingDetails.vue'),
	}, {
		path: '/requirementInspectorRankingList',
		name: 'RequirementInspectorRankingList',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/requirementInspectorRankingList.vue'),
	}, {
		path: '/requirementInspectorRankingDetails',
		name: 'RequirementInspectorRankingDetails',
		component: () => import('@/views/projectTracking/projectDashboardOverallDetails/requirementInspectorRankingDetails.vue'),
	}, {
		path: '/projectConfiguration',
		name: 'ProjectConfiguration',
		component: () => import('@/views/projectTracking/projectConfiguration.vue'),
	}, {
		path: '/myReimbursement',
		name: 'MyReimbursement',
		component: () => import('@/views/financialCategory/myReimbursement.vue'),
	}, {
		path: '/verifyReimbursement',
		name: 'VerifyReimbursement',
		component: () => import('@/views/financialCategory/verifyReimbursement.vue'),
	}, {
		path: '/reimbursementRecord',
		name: 'ReimbursementRecord',
		component: () => import('@/views/financialCategory/reimbursementRecord.vue'),
	}, {
		path: '/expenseArchive',
		name: 'ExpenseArchive',
		component: () => import('@/views/financialCategory/expenseArchive.vue'),
	}, {
		path: '/financialConfiguration',
		name: 'FinancialConfiguration',
		component: () => import('@/views/financialCategory/financialConfiguration.vue'),
	}, {
		path: '/serverMonitoring',
		name: 'ServerMonitoring',
		component: () => import('@/views/serverPage/serverMonitoring.vue'),
	}, {
		path: '/ICPFiling',
		name: 'ICPFiling',
		component: () => import('@/views/serverPage/ICPFiling.vue'),
	}, {
		path: '/domainNameRegistration',
		name: 'DomainNameRegistration',
		component: () => import('@/views/serverPage/domainNameRegistration.vue'),
	}, {
		path: '/lightweightApplicationServer',
		name: 'LightweightApplicationServer',
		component: () => import('@/views/serverPage/lightweightApplicationServer.vue'),
	}, {
		path: '/certificateSSL',
		name: 'CertificateSSL',
		component: () => import('@/views/serverPage/certificateSSL.vue'),
	}, {
		path: '/serverConfiguration',
		name: 'ServerConfiguration',
		component: () => import('@/views/serverPage/serverConfiguration.vue'),
	}, {
		path: '/userMess',
		name: 'UserMess',
		component: () => import('@/views/userAccount/userMess.vue'),
	}, {
		path: '/userOrder',
		name: 'UserOrder',
		component: () => import('@/views/userAccount/userOrder.vue'),
	}, {
		path: '/rewardDistribution',
		name: 'RewardDistribution',
		component: () => import('@/views/userAccount/rewardDistribution.vue'),
	}, {
		path: '/userConfiguration',
		name: 'UserConfiguration',
		component: () => import('@/views/userAccount/userConfiguration.vue'),
	}, {
		path: '/parkStore',
		name: 'ParkStore',
		component: () => import('@/views/parkPage/parkStore.vue'),
	}, {
		path: '/storeManagement',
		name: 'StoreManagement',
		component: () => import('@/views/parkPage/storeManagement.vue'),
	}, {
		path: '/parkConfiguration',
		name: 'ParkConfiguration',
		component: () => import('@/views/parkPage/parkConfiguration.vue'),
	}, {
		path: '/employmentNotice',
		name: 'EmploymentNotice',
		component: () => import('@/views/helpPage/employmentNotice.vue'),
	}, {
		path: '/shortcutKeyManual',
		name: 'ShortcutKeyManual',
		component: () => import('@/views/helpPage/shortcutKeyManual.vue'),
	}, {
		path: '/helpDocument',
		name: 'HelpDocument',
		component: () => import('@/views/helpPage/helpDocument.vue'),
	}, {
		path: '/updateExplanation',
		name: 'UpdateExplanation',
		component: () => import('@/views/helpPage/updateExplanation.vue'),
	}, {
		path: '/applicationProgram',
		name: 'ApplicationProgram',
		component: () => import('@/views/resourcePage/applicationProgram.vue'),
	}, {
		path: '/systemInstallation',
		name: 'SystemInstallation',
		component: () => import('@/views/resourcePage/systemInstallation.vue'),
	}, {
		path: '/scriptingTools',
		name: 'ScriptingTools',
		component: () => import('@/views/resourcePage/scriptingTools.vue'),
	}, {
		path: '/fileTemplate',
		name: 'FileTemplate',
		component: () => import('@/views/resourcePage/fileTemplate.vue'),
	}, {
		path: '/wallpaper',
		name: 'Wallpaper',
		component: () => import('@/views/resourcePage/wallpaper.vue'),
	}, {
		path: '/sharedPrinting',
		name: 'SharedPrinting',
		component: () => import('@/views/resourcePage/sharedPrinting.vue'),
	}, {
		path: '/resourceAllocation',
		name: 'ResourceAllocation',
		component: () => import('@/views/resourcePage/resourceAllocation.vue'),
	}, {
		path: '/pathInformation',
		name: 'PathInformation',
		component: () => import('@/views/pathPage/pathInformation.vue'),
	}, {
		path: '/pathInformationEdit',
		name: 'PathInformationEdit',
		component: () => import('@/views/pathPage/pathInformationEdit.vue'),
	}, {
		path: '/pathConfiguration',
		name: 'PathConfiguration',
		component: () => import('@/views/pathPage/pathConfiguration.vue'),
	}, {
		path: '/enterpriseDataPage',
		name: 'EnterpriseDataPage',
		type: '', // archive_overall_type
		component: () => import('@/views/enterpriseOperation/enterpriseDataPage.vue'),
	}, {
		path: '/enterprisedetailsDataPage',
		name: 'EnterprisedetailsDataPage',
		type: '', // archive_overall_type
		component: () => import('@/views/enterpriseOperation/enterprisedetailsDataPage.vue'),
	}, {
		path: '/enterpriseJoinPage',
		name: 'EnterpriseJoinPage',
		type: '', // 
		component: () => import('@/views/enterpriseOperation/enterpriseJoinPage.vue'),
	}, {
		path: '/enterpriseDataEdit',
		name: 'EnterpriseDataEdit',
		type: '', // 
		component: () => import('@/views/enterpriseOperation/enterpriseDataEdit.vue'),
	}, {
		path: '/addMembers',
		name: 'AddMembers',
		type: '', // 
		component: () => import('@/views/enterpriseOperation/addMembers.vue'),
	}, {
		path: '/subjectivePerspective',
		name: 'SubjectivePerspective',
		type: '', // 主观视角
		component: () => import('@/views/enterpriseOperation/subjectivePerspective.vue'),
	}, {
		path: '/bePendingPage',
		name: 'BePendingPage',
		type: '', // 待定
		component: () => import('@/views/enterpriseOperation/bePendingPage.vue'),
	}, {
		path: '/enterpriseConfiguration',
		name: 'EnterpriseConfiguration',
		type: '', // 
		component: () => import('@/views/enterpriseOperation/enterpriseConfiguration.vue'),
	}, {
		path: '/xqFinancialFeedback',
		name: 'XqFinancialFeedback',
		type: '', // 
		component: () => import('@/views/feedbackAllPage/xqFinancialFeedback.vue'),
	}, {
		path: '/xqFinancialFeedbackDetails',
		name: 'XqFinancialFeedbackDetails',
		type: '', // 
		component: () => import('@/views/feedbackAllPage/xqFinancialFeedbackDetails.vue'),
	}, {
		path: '/feedbackAllConfiguration',
		name: 'FeedbackAllConfiguration',
		type: '', // 
		component: () => import('@/views/feedbackAllPage/feedbackAllConfiguration.vue'),
	}]
}, {
	path: '/incomeAndExpenditureDetailsToDetailsDownLoad',
	name: 'IncomeAndExpenditureDetailsToDetailsDownLoad',
	component: () => import('@/views/myMessPage/incomeAndExpenditureDetailsToDetailsDownLoad.vue'),
}]

const router = new createRouter({
	history: createWebHistory(),
	routes: constantRoutes
})

router.beforeEach((to, from, next) => {
	let loginToken = localStorage.getItem('loginToken')
	console.log(loginToken, to, from, to.fullPath.includes('?token='), 'router beforeEach')
	if (!loginToken) {
		// console.log(to.fullPath.includes('?token='), from, 'from router beforeEach')
		// if (to.fullPath.includes('?token=') && from.fullPath == '/') {
		// 	// 从sso登录后返回
		// 	localStorage.setItem('loginToken', 1)
		// 	next();
		// } else {
		// 	// 跳转到sso登录
		// 	goLogin()
		// 	return
		// }

		if (from.fullPath == '/') {
			// 下载页 不进行登录校验
			if (to.fullPath.includes('/incomeAndExpenditureDetailsToDetailsDownLoad')) {
				next();
			} else {
				if (to.fullPath.includes('?token=')) {
					// 从sso登录后返回
					localStorage.setItem('loginToken', 1)
					next();
				} else {
					// 跳转到sso登录
					goLogin()
					return
				}
			}
		} else {
			next();
		}
		console.log(to.fullPath.includes('?token='), from, 'from router beforeEach')
	} else {
		// ***目前定位问题为 某个页面为缓存页面 在此期间新部署了最新代码并新增了新的页面（路由等） 可能会导致无法加载到新页面的最新的资源 导致报动态模块加载失败的错误
		// 路由守卫中的预防措施（再次出现问题时 对应着优化*）
		// meta: { keepAlive: true }
		// meta: { requiresFreshLoad: true } ,// 重要页面需要全新加载

		// // 如果从 keep-alive 的页面跳转，检查版本
		// const fromCached = from.meta?.keepAlive

		// if (fromCached) {
		// 	const hasUpdate = await versionManager.checkForUpdates()

		// 	if (hasUpdate && to.meta?.requiresFreshLoad) {
		// 		// 对于重要页面，强制刷新以确保加载最新代码
		// 		window.location.href = to.fullPath
		// 		return
		// 	}
		// }
		console.log(to, from, 'to, from router beforeEach')
		next();
	}
})

// 全局路由错误处理（20251126 新增）
router.onError((error, to) => {
	console.error('路由导航错误:error, to', error, to)

	if (error.message.includes('Failed to fetch dynamically imported module')) {
		console.log('🔄 检测到动态模块加载错误，准备恢复...')

		// 可以在这里添加全局恢复逻辑
		// setTimeout(() => {
		//   // 重试当前导航
		// router.push(to.fullPath)
		// }, 1000)
	}
})

export default router